import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../../styles/commonStyles/customDateInput.css";
import EventIcon from '@mui/icons-material/Event';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, getMonth, getYear, isValid, parse, parseISO } from "date-fns";
import { ChevronLeftOutlined, ChevronRightOutlined } from "@mui/icons-material";
import {
  Select,
  MenuItem,
} from "@mui/material";

const CustomDatePickerInput = ({
  name,
  value,
  handleInputChange,
  handleCalendarChange,
  datePickerRef,
  selectedDate,
  portalCalendar = false,
  minDate,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const maxDate = new Date();
    const currentYear = new Date().getFullYear();
    const selectedYear = selectedDate ? getYear(selectedDate) : currentYear;
    const maxYear = Math.max(currentYear, selectedYear);
    const years = Array.from({ length: maxYear - 1900 + 1 }, (_, i) => maxYear - i);
    
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const handleInputChangeWrapper = (e) => {
      const inputValue = e.target.value;
      handleInputChange(e);
      if (inputValue.length === 10) {
        const parsedDate = parse(inputValue, "MM/dd/yyyy", new Date());
        if (isValid(parsedDate)) {
          if (parsedDate >= new Date('1900-01-01')) {
            handleCalendarChange(parsedDate);
            setRefreshKey(prev => prev + 1);
          }
        }
      }
    };

  return (
    <>
      <div className="inputWrapper">
        <input
          type="text"
          className="inputDatepick"
          value={value}
          onChange={handleInputChangeWrapper}
          placeholder="MM/DD/YYYY"
          maxLength={10}
          name={name}
          autoComplete="off"
        />
        <EventIcon
          className="calendarIcon"
          onClick={() => setIsOpen(true)}
        />
      </div>
      <DatePicker
        key={refreshKey}
        ref={datePickerRef}
        open={isOpen}
        onClickOutside={(e) => {
          const target = e?.target;
          // Month/year MUI Select menus are portaled to body — don't close calendar
          if (
            target?.closest?.(
              ".MuiPopover-root, .MuiMenu-root, .MuiModal-root, [role='listbox']",
            )
          ) {
            return;
          }
          setIsOpen(false);
        }}
        selected={selectedDate}
        onChange={(date) => {
          handleCalendarChange(date);
          setIsOpen(false);
        }}
        dateFormat="MM/dd/yyyy"
        minDate={minDate || new Date("1900-01-01")}
        maxDate={maxDate}
        showPopperArrow={false}
        popperPlacement="bottom-start"
        popperContainer={
          portalCalendar
            ? ({ children }) => createPortal(children, document.body)
            : undefined
        }
        customInput={<></>}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
              minWidth:'250px'
            }}
          >
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{border:'none',background:'none'}}>
                <ChevronLeftOutlined sx={{fontSize:"24px",color:'#000',cursor:"pointer",visibility: prevMonthButtonDisabled ? 'hidden' : 'visible'}}/>
            </button>
            <Select   
              variant="standard"
              sx={{width:'70px'}}
              className='react-datepicker__current-year'
              value={getYear(date)}
              onChange={({ target: { value } }) => {changeYear(value)}}
              onMouseDown={(e) => e.stopPropagation()}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: {xs:'300px',sm:'300px',md:'300px',lg:'300px'},
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    '&::-webkit-scrollbar': {
                        width: '4px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'grey',
                        borderRadius: '25px',
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                      },
                  },
                },
                disableScrollLock: true,
                sx: {
                  zIndex: 99999,
                },
              }}
            >
              {years.map((option) => (
                <MenuItem 
                  key={option} 
                  value={option}
                  sx={{
                    fontSize: '14px',
                    minHeight: 'unset',
                    fontFamily:'proxima-regular',
                    padding:'6px 6px'
                  }}
                  >
                  {option}
                </MenuItem>
              ))}
            </Select>
            <Select
               sx={{width:'100px',}} 
               className='react-datepicker__current-month'
               variant="standard"
               value={months[getMonth(date)]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
                onMouseDown={(e) => e.stopPropagation()}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: {xs:'300px',sm:'300px',md:'300px',lg:'300px'},
                      overflowY: 'auto',
                      '&::-webkit-scrollbar': {
                        width: '4px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'grey',
                        borderRadius: '25px',
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                      },
                    },
                  },
                  disableScrollLock: true,
                  sx: {
                  zIndex: 99999,
                },
                }}
            >
              {months.map((option) => (
                <MenuItem 
                  key={option}
                  value={option}
                  sx={{
                    fontSize: '14px',
                    minHeight: 'unset',
                    fontFamily:'proxima-regular',
                    padding:'6px 6px'
                  }}
                  >
                  {option}
                </MenuItem>
              ))}
            </Select>
            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{border:'none',background:'none'}}>
               <ChevronRightOutlined sx={{fontSize:"24px",color:'#000',cursor:"pointer",visibility: nextMonthButtonDisabled ? 'hidden' : 'visible' }} />
            </button>
          </div>
        )}
      />
    </>
  );
};

export default CustomDatePickerInput;